import { ModulePermission } from '@luminovo/api-contracts';
import { assertUnreachable } from '@luminovo/commons';

export type ModulePermissionTest =
    | ModulePermission
    | {
          permissions: ModulePermission[];
          type: 'any' | 'all';
      }
    | ((permissions: ModulePermission[]) => boolean);

export function isAuthorizedForModule(modulePermissions: ModulePermission[], test: ModulePermissionTest): boolean {
    if ('module' in test) {
        return modulePermissions.some((p) => p.module === test.module && p.permission === test.permission);
    }
    if (typeof test === 'function') {
        return test(modulePermissions);
    }
    if (test.type === 'any') {
        return test.permissions.some((testP) =>
            modulePermissions.some((p) => p.module === testP.module && p.permission === testP.permission),
        );
    } else if (test.type === 'all') {
        return test.permissions.every((testP) =>
            modulePermissions.some((p) => p.module === testP.module && p.permission === testP.permission),
        );
    }
    assertUnreachable(test.type);
}
